







































































import { Component } from 'vue-property-decorator';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';

@Component({ name: 'ThirdPartyAccountDetails' })
export default class extends SaascadaVue {

    get account() {
        return InstitutionAccountModule.thirdPartyAccount;
    }

}
